module.exports = __webpack_public_path__ + "img/confirm.187bc084.png";